import React from 'react';
import Breadcrumbs from '~/components/Breadcrumbs';
import CompanyBanner from '~/components/Companies/CompanyBanner';
import CompanyIntro from '~/components/Companies/CompanyIntro';
import CompanyOfficesListPanel from '~/components/Companies/CompanyOfficesListPanel';
import PartnershipPanel from '~/components/Companies/PartnershipPanel';
import ReviewBlock from '~/components/Reviews/ReviewBlock';
import Container from '~/components/ui/Container';
import { currentUrl } from '~/helpers/projectConstant';
import DefaultLayout from '~/layouts/DefaultLayout';
import type { ChainProfileProps } from '~/types/Chain';

export const ChainProfile: React.FC<ChainProfileProps> = ({
  name,
  slug,
  logoUrl,
  description,
  offices,
  score,
  partnerText,
  reviews,
  statistics,
  banner,
}) => {
  const breadcrumbLinks = [
    { name: 'Home', linkTo: '/' },
    { name: 'Ketens', linkTo: '/over/ketens' },
    { name, linkTo: currentUrl },
  ];

  return (
    <DefaultLayout
      breadcrumbs={<Breadcrumbs links={breadcrumbLinks} variant="inverted" />}
      bgClassName="bg-blue-700"
    >
      <CompanyBanner
        banner={banner}
        companyName={name}
        companyLogo={logoUrl}
        companyType="chain"
      />
      <CompanyIntro
        companyName={name}
        companyDescription={description}
        companyStats={{
          reviewsCount: statistics.numberOfReviews,
          officesCount: statistics.numberOfOffices,
          employeesCount: statistics.numberOfAdvisors,
        }}
      />
      <Container className="pb-16 md:pb-24">
        <PartnershipPanel
          hasPartnership={!!partnerText}
          partnershipDetailsLink={`/over/keten/${slug}/samenwerking`}
        />
        <ReviewBlock
          title="Reviews van aangesloten kantoren"
          scoreDisplay={score}
          reviews={reviews}
          totalReviews={statistics.numberOfReviews}
          name={name}
          reviewUrl={`/beoordelen?company=${slug}`}
          reviewIndexUrl={`/over/keten/${slug}/beoordelingen`}
        />
        <CompanyOfficesListPanel companyName={name} offices={offices} />
      </Container>
    </DefaultLayout>
  );
};
